import React, { useContext } from 'react'

// mui
import { Alert, CircularProgress } from '@mui/material'

// pages
import NoAccess from '../../../pages/authentication/NoAccess/NoAccess.page'

// gql
import { useQuery } from '@apollo/client'
import { GET_AUTH_GROUP } from '../../../graphql/authentication/authentication.queries'

const ProtectedRoute = ({ component: Component, groupsAllowed = [], ...rest}) => {

    let usersGroups = []
    const { data, loading, error } = useQuery(GET_AUTH_GROUP)

    

    if(loading) return <CircularProgress />

    console.info(error)
    if(error) return <Alert severity="error">{error.message}</Alert>

    if(data && data.userAuthGroup) { 
        usersGroups = [...data.userAuthGroup]
    }

    // check if their group is in the "groupsAllowed" array
    let canAccess = false
    groupsAllowed.forEach(groupAllowed => {
        usersGroups.forEach(userGroup => {
            if(groupAllowed == userGroup.name) { canAccess = true}
        })
    })
    // if yes, return the Route component
    // if not, return the NoAccess component
    return (<>
        { canAccess ? <Component usersGroups={usersGroups} {...rest} /> : <NoAccess {...rest} /> }
    </>)
}

export default ProtectedRoute